import Vue from 'vue'
import Router from 'vue-router'

//import NotFound from '../pages/elements/404'

Vue.use(Router)

const router = new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/go',
      beforeEnter() { location.href = 'https://go.apif.app' }
    },
    {
      path: '/signup',
      beforeEnter() { location.href = 'https://go.apif.app/#/signup' }
    },
    {
      name: 'home',
      path: '/',
      component: require('@/pages/Home').default,
    },
    {
      name: 'privacy',
      path: '/privacy',
      component: require('@/pages/legal/Privacy').default,
    },
    {
      name: 'terms',
      path: '/terms',
      component: require('@/pages/legal/Terms').default,
    },
    {
      name: 'surveyFeedback',
      path: '/survey/feedback',
      component: require('@/pages/surveys/FeedbackChurn').default,
    },
  ],
})

export default router;